import _ from 'lodash';

/** Retrieves the intial State Object */
const getNewStateObject = (isFetchingOnMount) => {
  return {
    isSelectedClassifier: false,
    targetLabels: [],
    loading: isFetchingOnMount,
    loadingComponent: '',
    labelToAdd: {},
    weightedLabels: { weightedClfTargets:[] },
    labelAutocompleteInputValue: '',
    filterClassifierAutocompleteValue: '',
    clfTargetTableRowId: 0,
    targetLabelRowId: 0,
    pageNotification: {show: false, msg: '', type: ''},
    activeTab: 'attachedLabelsTab',
    isModalActive: false,
    modalItem: {},
    videoResults: [],
    boxResults: {},
    mturkEvaluatorState: {},
    mturkActiveTab: 'mturkVideo'
  };
}

const getPageNotificationObject = (target) => {
  return {
    show: true,
    target: target,
    msg: 'The changes were saved successfully',
    type: 'success'
  };
}

const getDurationTime = (time) => {
  var minutes = Math.floor(time / 60),
      seconds = time - minutes * 60;
  seconds = Math.round(seconds * 100) / 100;
  seconds = Math.round(seconds);

  return ((minutes < 10 ? '0' + minutes : minutes) + ':' +
          (seconds  < 10 ? '0' + seconds : seconds));
}

const getVideoFrames = (s3ImagesArray, sliderMarkIncrement, duration) => {
  const frames = {};
  s3ImagesArray.forEach((imageFrame, position) => {
    const sliderPosition = (position * sliderMarkIncrement);
    if (sliderPosition < 100 || (sliderPosition > 100 && (sliderPosition - sliderMarkIncrement) < 100 )) {
      const sliderTime = ((sliderPosition * duration) / 100);
      _.assign(frames, {[sliderPosition < 100 ? sliderPosition : 100]: {
        position: sliderPosition < 100 ? sliderPosition : 100,
        mark: sliderPosition < 100 ? getDurationTime(sliderTime) : getDurationTime(duration),
        frame: imageFrame
      }});
    }
  });
  return frames;
}

const getThumbnailObject = (videoResult) => {
  const durationTime = getDurationTime(videoResult.video.length),
        s3ImagesArray = videoResult.video.s3Images.split('|'),
        sliderMarkIncrement = _.round(100 / s3ImagesArray.length),
        defaultStep = s3ImagesArray.length > 5 ? sliderMarkIncrement * 4 : sliderMarkIncrement * 1,
        frames = getVideoFrames(s3ImagesArray, sliderMarkIncrement, videoResult.video.length);
  return {
    videoId: videoResult.videoId,
    duration: durationTime,
    step: sliderMarkIncrement,
    defaultFrame: defaultStep,
    page: videoResult.video.page,
    frames: frames,
    currentPosition: -1
  };
}

const assignNewVideoDetectorState = (prevVideoDetectorResults, videoDetectorResults, clfTargetTableRowId, videoResults) => {
  const state = {};
  const shouldAssignVideo = videoDetectorResults.length > 0 ? videoDetectorResults[0].clfTargetId === clfTargetTableRowId : false;
  if (shouldAssignVideo && !_.isEqual(prevVideoDetectorResults, videoDetectorResults)) {
    const videoResults = videoDetectorResults.map((result) => {
      return getThumbnailObject(result);
    });
    _.assign(state, {videoResults: videoResults});
  } else if (!_.isEmpty(videoResults) && !shouldAssignVideo) {
    _.assign(state, {videoResults: []});
  }
  return state;
}

const assignBoxDetectorState = (prevBoxDetectorResults, boxDetectorResults, clfTargetTableRowId, boxResults) => {
  const state = {};
  const shouldAssignBox = boxDetectorResults.length > 0 ? boxDetectorResults[0].clfTargetId === clfTargetTableRowId : false;
  if (shouldAssignBox && !_.isEqual(prevBoxDetectorResults, boxDetectorResults)) {
    const newBoxResults = _.groupBy(boxDetectorResults, (elem)=>{ elem.isActive = false;return elem.box.videoId; });
    _.assign(state, {boxResults: newBoxResults});
  } else if (!_.isEmpty(boxResults) && !shouldAssignBox) {
    _.assign(state, {boxResults: []});
  }
  return state;
}

const assignLoadingState = (prevLoading, currentLoading) => {
  const state = {};
  if (prevLoading && currentLoading) {
    _.assign(state, {loading: false});
  }
  return state;
}

const assignLoadingComponentState = (prevLoadingComponent, loadingComponent) => {
  const state = {};
  if (prevLoadingComponent === loadingComponent && !_.isEmpty(loadingComponent)) _.assign(state, {loadingComponent: ''});

  return state;
}

const assignEmptyWeightedLabels = (isMount, prevClassifier, classifier) => {
  const state = {};
  if (!_.isEqual(prevClassifier, classifier) && !isMount) {
    _.assign(state, {weightedLabels: { weightedClfTargets:[] }});
  }
  return state;
}

const assignWeightedLabelsUpdateState = (prevClfWeightedTarget, clfWeightedTarget, weightedLabels) => {
  const state = {};
  if (!_.isEqual(prevClfWeightedTarget, clfWeightedTarget)) {
    const clfWeightedTargetLabels = !!clfWeightedTarget ? clfWeightedTarget.clfTarget.weightedClfTargets : [];
    _.remove(weightedLabels.weightedClfTargets, (item) => {
      return !item.action || item.action!== 'create';
    });
    weightedLabels.id = !!clfWeightedTarget ? clfWeightedTarget.clfTarget.id : 0;
    weightedLabels.weightedClfTargets = weightedLabels.weightedClfTargets.concat(clfWeightedTargetLabels);
    _.assign(state, {weightedLabels: weightedLabels, clfTargetTableRowId: weightedLabels.id});
  }
  return state;
}

const assignSavedWeightedTargetState = (isMount, prevSavedWeightedTarget, savedWeightedTarget, weightedLabels) => {
  const state = {};
  if (!_.isEqual(prevSavedWeightedTarget, savedWeightedTarget) && !isMount) {
    const weightedClfTargets = weightedLabels.weightedClfTargets;
    let weightedLabel;
    if (_.has(savedWeightedTarget, 'okay') && savedWeightedTarget.okay) {
      weightedLabel = _.find(weightedClfTargets, {action: 'delete'});
      _.remove(weightedLabels.weightedClfTargets, (item) => {
        return item.labelId === weightedLabel.labelId;
      });
    } else {
      weightedLabel = _.find(weightedClfTargets, {labelId: savedWeightedTarget.weightedClfTarget.labelId});
      delete weightedLabel.action;
    }
    let isLoading = true;

    if (!_.some(weightedClfTargets, (target) => {return _.has(target, 'action')})) {
      _.assign(state, {pageNotification: getPageNotificationObject('attachedLabels')});
        isLoading = false;
    }
    _.assign(state, {weightedLabels: weightedLabels, loading: isLoading});
  }
  return state;
}

const assignEmptyPageNotificationState = (prevPageNotification, pageNotification) => {
  const state = {};
  if (prevPageNotification.show && pageNotification.show) {
    _.assign(state, {pageNotification: {show: false, msg: '', type: '', target: ''}});
  }
  return state;
}

const assignNewMturkEvaluator = (prevMturkEvaluatorProp, mturkEvaluatorState, mturkEvaluatorProp, targetLabelId) => {
  const state = {};
  if (!!mturkEvaluatorProp && mturkEvaluatorProp.id !== mturkEvaluatorState.id) {
    _.assign(state, {mturkEvaluatorState: mturkEvaluatorProp});
  } else if (!!prevMturkEvaluatorProp && !mturkEvaluatorProp) {
    const mturkEvaluator = {
      title: '', description: '', question: '', targetLabelId: targetLabelId,
      targetLabel: {targetClassifier: { hitEnabled: false }}
    };
    _.assign(state, {mturkEvaluatorState: mturkEvaluator});
  }
  return state;
}

const cloneTurkProps = (turkQaEnabled, savedTurkQaEnabled) => {
  turkQaEnabled.id = savedTurkQaEnabled.classifierTarget.id;
  turkQaEnabled.imageQaEnabled = savedTurkQaEnabled.classifierTarget.imageQaEnabled;
  turkQaEnabled.boxQaEnabled = savedTurkQaEnabled.classifierTarget.boxQaEnabled;
  turkQaEnabled.pageQaEnabled = savedTurkQaEnabled.classifierTarget.pageQaEnabled;
  turkQaEnabled.videoQaEnabled = savedTurkQaEnabled.classifierTarget.videoQaEnabled;
}

const assignSavedMturkEvaluator = (prevSavedMTurkEvaluator, savedMTurkEvaluator, mturkEvaluatorState, turkQaEnabled, savedTurkQaEnabled) => {
  const state = {};
  if (!!savedMTurkEvaluator && !_.isEqual(prevSavedMTurkEvaluator, savedMTurkEvaluator) &&
        (!mturkEvaluatorState.id || (!!mturkEvaluatorState.id && mturkEvaluatorState.id === savedMTurkEvaluator.mturkEvaluator.id)) ) {
          _.assign(state, {
            pageNotification: getPageNotificationObject('mturkEvaluator'),
            mturkEvaluatorState: _.clone(savedMTurkEvaluator.mturkEvaluator, true)
          });
          cloneTurkProps(turkQaEnabled, savedTurkQaEnabled);
  }
  return state;
}

const getComponentState = (isMount, prevProps, prevState, state, props) => {
  const newState = {};
  const { weightedLabels, pageNotification, loading, clfTargetTableRowId, videoResults,
    boxResults, loadingComponent, mturkEvaluatorState, targetLabelRowId } = state;
  const { clfWeightedTarget, classifier, savedWeightedTarget, videoDetectorResults,
    boxDetectorResults, mturkEvaluator, savedMTurkEvaluator, turkQaEnabled, savedTurkQaEnabled } = props;
  _.assign(newState, assignLoadingState(prevState.loading, loading));
  _.assign(newState, assignLoadingComponentState(prevState.loadingComponent, loadingComponent));
  _.assign(newState, assignWeightedLabelsUpdateState(
    prevProps.clfWeightedTarget,
    clfWeightedTarget,
    weightedLabels)
  );
  _.assign(newState, assignNewMturkEvaluator(prevProps.mturkEvaluator, mturkEvaluatorState, mturkEvaluator, targetLabelRowId));
  _.assign(newState, assignSavedMturkEvaluator(prevProps.savedMTurkEvaluator, savedMTurkEvaluator, mturkEvaluatorState, turkQaEnabled, savedTurkQaEnabled));
  _.assign(newState, assignEmptyWeightedLabels(isMount, prevProps.classifier, classifier));
  _.assign(newState, assignSavedWeightedTargetState(
    isMount,
    prevProps.savedWeightedTarget,
    savedWeightedTarget,
    weightedLabels)
  );
  _.assign(newState, assignEmptyPageNotificationState(prevState.pageNotification, pageNotification));
  _.assign(newState, assignNewVideoDetectorState(prevProps.videoDetectorResults, videoDetectorResults, clfTargetTableRowId, videoResults));
  _.assign(newState, assignBoxDetectorState(prevProps.boxDetectorResults, boxDetectorResults, clfTargetTableRowId, boxResults));

  return newState;
}

module.exports = {
  getNewStateObject,
  getComponentState
}



// WEBPACK FOOTER //
// ./src/components/classifier/classifier.state.jsx